import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _SpinningLoadingIcon;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Table as AntTable } from 'antd';
import styled from 'styled-components';
import chroma from 'chroma-js';
import { SpinningLoadingIcon } from '../LoadingSpinner';
/* copy-pasted from antd, to solve TS4023 error */

/* end copy-paste */
var CLASSNAME_HELPER = {
  DARKER_BG: 'table-darker-row',
  LIGHTER_BG: 'table-lighter-row',
  GREYED_OUT: 'table-greyed-out'
};
var Table = styled(AntTable).attrs(function (props) {
  return {
    loading: props.loading ? {
      indicator: _SpinningLoadingIcon || (_SpinningLoadingIcon = /*#__PURE__*/React.createElement(SpinningLoadingIcon, null))
    } : false,
    pagination: props.pagination ? _objectSpread(_objectSpread({}, props.pagination), {}, {
      total: props.count
    }) : false,
    locale: props.locale || {
      triggerAsc: '',
      triggerDesc: '',
      cancelSort: ''
    }
  };
}).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['stickyHeadPosition', 'stickyPaginationPosition'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-table {\n    border-radius: 0;\n    border: ", " 1px solid;\n    margin-bottom: ", ";\n\n    &-thead {\n      .ant-table-cell-fix-left {\n        z-index: 2;\n      }\n    }\n\n    &-pagination {\n      z-index: 2;\n    }\n  }\n\n  table {\n\n    tr > th {\n      background-color: ", ";\n      border-radius: 0 !important;\n      font-weight: bold;\n    }\n    thead.ant-table-thead {\n      & > tr > th {\n        z-index: 1;\n        position: ", ";\n        top: ", ";\n      }\n    }\n    tbody > tr.ant-table-row {\n      transition: 0.1s all ease-in;\n\n      & > td.ant-table-cell.hide-on-hover > * {\n        opacity: 0;\n      }\n\n      &:hover {\n        & > td.ant-table-cell {\n          &:first-child::before {\n            content: \"\";\n            position: absolute;\n            left: -1px;\n            top: 0;\n            height: 100%;\n            width: 3px;\n            background-color: ", ";\n          }\n\n          &.hide-on-hover > * {\n            opacity: 1;\n          }\n        }\n      }\n\n      &, &:hover {\n        & > td.ant-table-cell {\n          border-bottom-color: ", ";\n          background-color: ", ";\n        }\n        &:not(.", "):not(.", ") {\n          &:nth-child(odd) > td.ant-table-cell {\n            background-color: ", ";\n          }\n        }\n        &.", " > td.ant-table-cell {\n          background-color: ", ";\n        }\n        &.", " > td.ant-table-cell {\n          background-color: ", ";\n        }\n\n        &.", " {\n          opacity: 0.32;\n        }\n      }\n    }\n  }\n\n  ul.ant-pagination {\n    position: ", ";\n    bottom: ", ";\n    width: ", ";\n    background-color: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin: ", ";\n    left: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.grey;
}, function (props) {
  return typeof props.stickyPaginationPosition === 'number' && '3rem';
}, function (props) {
  return props.theme.colors.grey;
}, function (props) {
  return typeof props.stickyHeadPosition === 'number' && !props.loading && 'sticky';
}, function (props) {
  return typeof props.stickyHeadPosition === 'number' && !props.loading ? "".concat(props.stickyHeadPosition, "px") : undefined;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.showBottomRowBorder ? props.theme.colors.grey : 'transparent';
}, function (props) {
  return props.theme.colors.light;
}, CLASSNAME_HELPER.DARKER_BG, CLASSNAME_HELPER.LIGHTER_BG, function (props) {
  return chroma(props.theme.colors.grey).brighten(0.3).hex();
}, CLASSNAME_HELPER.DARKER_BG, function (props) {
  return chroma(props.theme.colors.grey).brighten(0.3).hex();
}, CLASSNAME_HELPER.LIGHTER_BG, function (props) {
  return props.theme.colors.light;
}, CLASSNAME_HELPER.GREYED_OUT, function (props) {
  return typeof props.stickyPaginationPosition === 'number' && 'fixed';
}, function (props) {
  return typeof props.stickyPaginationPosition === 'number' && 0;
}, function (props) {
  return typeof props.stickyPaginationPosition === 'number' && '100%';
}, function (props) {
  return typeof props.stickyPaginationPosition === 'number' && props.theme.colors.light;
}, function (props) {
  return typeof props.stickyPaginationPosition === 'number' && '1rem';
}, function (props) {
  return typeof props.stickyPaginationPosition === 'number' && "calc(1rem + ".concat(props.stickyPaginationPosition, "px)");
}, function (props) {
  return typeof props.stickyPaginationPosition === 'number' && '0';
}, function (props) {
  return typeof props.stickyPaginationPosition === 'number' && '0';
});
Table.defaultProps = {
  size: 'middle',
  stickyHeadPosition: null,
  stickyPaginationPosition: null
};
var CustomTable = Table;
CustomTable.CLASSNAME_HELPER = CLASSNAME_HELPER;
export default CustomTable;